{
  "fr": {
    "window": {
      "app": "App",
      "customersDashboard": "Accueil",
      "customersDecisionDocuments": "Décision",
      "customersDecisionProposals": "Propositions",
      "customersDecisionTickets": "Décision",
      "customersDecisionTicketsShow": "Décision",
      "customersDecisions": "Décisions",
      "customersDocuments": "Documents",
      "customersDocumentsAll": "Aperçu des documents",
      "customersDocumentsFolder": "Catégorie de documents",
      "customersDocumentsFolders": "Catégories de documents",
      "customersInspirationLists": "Inspirations",
      "customersInspirationListsShow": "Inspirations",
      "customersInstallmentTerms": "Paiements partiels",
      "customersIssues": "Après-vente",
      "customersIssuesList": "Après-vente",
      "customersProjectInformation": "Information Projet",
      "customersQuestionLists": "FAQs",
      "customersQuestionListsShow": "FAQs",
      "customersRoot": "Accueil",
      "customersRootSettingsProfile": "Profil",
      "customersSettingsProfile": "Profil",
      "customersTickets": "Conversations",
      "customersTicketsNew": "Nouvelle Conversation",
      "customersTicketsShow": "Conversation",
      "employeesClientContacts": "Contacts",
      "employeesClientContactsNew": "Nouveau contact",
      "employeesClientContactsNewCustomer": "Nouveau Client",
      "employeesClientContactsNewPartner": "Nouveau Partenaire",
      "employeesClientContactsType": "Contacts",
      "employeesClientDashboard": "Accueil",
      "employeesClientProjects": "Projets",
      "employeesClientProjectsNew": "Nouveay projet",
      "employeesClientTickets": "Conversations",
      "employeesClientTicketsNew": "Nouvelle Conversation",
      "employeesClientTicketsShow": "Conversation",
      "employeesMarketplace": "Marketplace",
      "employeesProjectActivity": "Activités",
      "employeesProjectAnnouncements": "Actualités",
      "employeesProjectDecisionActivity": "Activity",
      "employeesProjectDecisionDocuments": "Décision",
      "employeesProjectDecisionProposalTemplate": "Modèles de proposition",
      "employeesProjectDecisionProposals": "Proposals",
      "employeesProjectDecisionReminders": "Rappels",
      "employeesProjectDecisionTickets": "Conversations",
      "employeesProjectDecisionTicketsShow": "Conversation",
      "employeesProjectDecisionTypeNew": "Nouvelle Décision",
      "employeesProjectDecisionTypes": "Décisions",
      "employeesProjectDecisions": "Décisions",
      "employeesProjectDecisionsEdit": "Décisions",
      "employeesProjectDecisionsNew": "Nouvelle Décision",
      "employeesProjectDocuments": "Documents",
      "employeesProjectInformationPageActivity": "Activité",
      "employeesProjectInformationPageAftercare": "Après-vente",
      "employeesProjectInformationPageDecisions": "Décisions",
      "employeesProjectInformationPageDocuments": "Documents",
      "employeesProjectInformationPageInformation": "Information",
      "employeesProjectInformationPageInstallments": "Paiements partiels",
      "employeesProjectInformationPageLevels": "Information",
      "employeesProjectInformationPageMilestones": "Jalons",
      "employeesProjectInformationPageSpaces": "Espaces",
      "employeesProjectInformationPageSurveys": "Formulaires",
      "employeesProjectInformationPageTasks": "Tasks",
      "employeesProjectInformationPageTasksV2": "Tâches v2",
      "employeesProjectInformationPageTickets": "Conversations",
      "employeesProjectInstallmentGroup": "Finances",
      "employeesProjectInstallmentGroupNew": "Nouvelle période de Versement",
      "employeesProjectInstallmentGroups": "Finances",
      "employeesProjectInstallmentGroupsList": "Finances",
      "employeesProjectInstallmentGroupsMatrix": "Versements",
      "employeesProjectInstallmentNew": "Nouveau Versements",
      "employeesProjectIssueListTypeIssues": "Après-vente",
      "employeesProjectIssueListTypeNew": "Nouveau liste de points",
      "employeesProjectIssueListTypeUnits": "Liste de points - Présentation de l'unité",
      "employeesProjectIssueListTypes": "Listes de points",
      "employeesProjectIssueListUnitDocuments": "Points d'unité - Documents",
      "employeesProjectIssueListUnitIssues": "Points d'unité",
      "employeesProjectIssueListUnitTickets": "Points d'unité - Conversations",
      "employeesProjectIssueListUnitTicketsShow": "Conversations",
      "employeesProjectIssueListsNew": "Nouveaux points",
      "employeesProjectMilestones": "Jalons",
      "employeesProjectQuestionLists": "FAQs",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Ventes",
      "employeesProjectSurveySummary": "Formulaire",
      "employeesProjectSurveyTypes": "Formulaires",
      "employeesProjectSurveys": "Formulaire",
      "employeesProjectTickets": "Conversations",
      "employeesProjectTicketsEmailConversations": "Courriels",
      "employeesProjectTicketsEmailConversationsShow": "Courriel",
      "employeesProjectTicketsNew": "Nouvelle Conversation",
      "employeesProjectTicketsShow": "Conversations",
      "employeesProjectTodoGroups": "Tâches v2",
      "employeesProjectTodoLists": "Tâches",
      "employeesSettingsClientAftercare": "Suivi",
      "employeesSettingsClientInformation": "Admin",
      "employeesSettingsClientIntegrations": "Intégrations",
      "employeesSettingsProfile": "Profil",
      "level": "Niveau",
      "mployeesProjectInstallmentGroups": "Finances",
      "partnersClientProjects": "Projets",
      "partnersProjectDecisionDocuments": "Documents",
      "partnersProjectDecisionProposals": "Propositions",
      "partnersProjectDecisionTickets": "Conversations",
      "partnersProjectDecisionTicketsShow": "Conversation",
      "partnersProjectDecisionTypesItems": "Décisions",
      "partnersProjectDecisions": "Décisions",
      "partnersProjectDocuments": "Documents",
      "partnersProjectDocumentsUnit": "Documents",
      "partnersProjectIssueListTypeIssues": "Liste de points - Tous les points",
      "partnersProjectIssueListTypeUnits": "Liste de points - Présentation de l'unité",
      "partnersProjectIssueListTypes": "Listes de points",
      "partnersProjectIssueListUnitDocuments": "Points d'unité - Documents",
      "partnersProjectIssueListUnitIssues": "Points d'unité",
      "partnersProjectIssueListUnitTickets": "Points d'unité - Conversations",
      "partnersSettingsProfile": "Profile",
      "root": "App"
    }
  }
}
